import { Component, EventEmitter, Output, OnInit } from '@angular/core';
import { MachineService } from '../../services/machine.service';
import {Machine} from "../../models/machine";
import {AccountService} from "../../services/account.service";
import {UserService} from "../../services/user.service";

@Component({
	moduleId: module.id,
	selector: 'machine-reports',
	templateUrl: 'machine-reports.html',
	styleUrls: ['machine-reports.scss']
})

export class MachineReportsComponent implements OnInit {
    @Output() onMachineGet = new EventEmitter<any>();

    private machines: any[];
    public selectedMachines: any[];
    constructor(
        private machineService: MachineService,
        private accountService: AccountService,
        private userService: UserService
    ) {};

    getMachines(): void {
        let self = this;
        let accountRole = this.userService.accountRole;
        let userId = this.userService.userId;
        this.machineService.getMachinesByRole(accountRole, userId)
        .then(machines => {
            self.pushMachines(machines);
        })
    };

    pushMachines(machines): void {
        let self = this;
        self.machines = machines;
        self.selectedMachines = [];
        for(let i in self.machines){
            self.selectedMachines.push({'machine': self.machines[i], 'selected': false});
        }
        this.onMachineGet.emit(self.selectedMachines);
    }

    selectAllMachines(checked: boolean): void {
        if (this.selectedMachines && this.selectedMachines.length) {
            for(let m of this.selectedMachines){
                m.selected = checked;
            }
        }
    };

    ngOnInit(): void {
        this.getMachines();
    };


}



// WEBPACK FOOTER //
// ./src/app/components/machine-reports/machine-reports.component.ts